import { classNames } from "@opensea/ui-kit"

export const CANCEL_ORDER_TABLE_COLUMN_CLASSNAMES = {
  item: classNames("grow first:pl-0"),
  price: classNames("w-[140px] justify-end"),
}
